import { render, staticRenderFns } from "./CheckoutAutomation.vue?vue&type=template&id=a5ec18d2&scoped=true"
import script from "./CheckoutAutomation.vue?vue&type=script&lang=js"
export * from "./CheckoutAutomation.vue?vue&type=script&lang=js"
import style0 from "./CheckoutAutomation.vue?vue&type=style&index=0&id=a5ec18d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ec18d2",
  null
  
)

export default component.exports